import { create } from 'zustand'

type State = {
  bottleType: string
  bottleName: string
  targetOfBottle: string
  bottleAmount: string
  bottleDate: {
    from: string
    to: string
  }
}

type Action = {
  addTypeOfBottle: (bottleType: string) => void
  addBottleName: (bottleName: string) => void
  addTargetOfBottle: (targetOfBottle: string) => void
  addBottleAmount: (bottleAmount: string) => void
  addBottleDate: (bottleDate: string[]) => void
  clearAllFields: () => void
}

export const useCreateBottle = create<State & Action>((set) => ({
  bottleType: '',
  bottleName: '',
  targetOfBottle: '',
  bottleAmount: '',
  bottleDate: {
    from: '',
    to: '',
  },
  addTypeOfBottle: (bottleType: string) => set((set: any) => ({ bottleType })),
  addBottleName: (bottleName: string) => set((set: any) => ({ bottleName })),
  addTargetOfBottle: (targetOfBottle: string) => set((set: any) => ({ targetOfBottle })),
  addBottleAmount: (bottleAmount: string) => set((set: any) => ({ bottleAmount })),
  addBottleDate: (bottleDate: string[]) =>
    set((set: any) => ({ bottleDate: { from: bottleDate[0], to: bottleDate[1] } })),
  clearAllFields: () =>
    set((set: any) => ({
      bottleType: '',
      bottleName: '',
      targetOfBottle: '',
      bottleAmount: '',
      bottleDate: {
        from: '',
        to: '',
      },
    })),
}))
